import {
  type SetPasswordCommand,
  type SignInResult,
  postAuthSetPassword,
} from "Infrastructure/Api/Api";
import type { SetPasswordStep } from "State/Auth/Models/AuthStateModels";
import { signInAsync } from "State/Auth/SignIn/SignInState";
import { setToken } from "Utils/Storage/LocalStorage/LocalStorageUtils";
import { trackUserIdentification } from "Utils/TrackingUtils";
import { call, put, takeLatest } from "typed-redux-saga";
import { createAction, createAsyncAction, getType } from "typesafe-actions";

export const TOKEN_ERROR = "TOKEN_ERROR";

export const setPasswordAsync = createAsyncAction(
  "@auth/SET_PASSWORD_REQUEST",
  "@auth/SET_PASSWORD_SUCCESS",
  "@auth/SET_PASSWORD_FAILURE",
)<SetPasswordCommand, SignInResult, Error>();

export const setPasswordSetStep = createAction(
  "@auth/SET_SET_PASSWORD_STEP",
)<SetPasswordStep>();

function* setPassword(
  action: ReturnType<typeof setPasswordAsync.request>,
): Generator {
  try {
    const response = yield* call(postAuthSetPassword, action.payload);
    if (response.status === 200) {
      if (response.data) {
        yield put(setPasswordAsync.success(response.data));
        setToken(response.data);
        trackUserIdentification();

        yield put(signInAsync.success(response.data));
      } else {
        yield put(setPasswordAsync.failure(new Error()));
      }
    } else {
      // Check if error response contains Token key, fast solution, later should be completely refactored and replaced with react query
      const hasTokenError =
        response.data?.errors && "Token" in response.data.errors;
      const errorMessage = hasTokenError
        ? TOKEN_ERROR
        : `Error in action ${action.type}`;

      yield put(
        setPasswordAsync.failure(
          new Error(errorMessage, {
            cause: response.status,
          }),
        ),
      );
    }
  } catch (err) {
    yield put(setPasswordAsync.failure(err as Error));
  }
}
export function* setPasswordSaga() {
  yield takeLatest(getType(setPasswordAsync.request), setPassword);
}
